import {Component, Inject, Input, OnChanges, OnInit} from '@angular/core';
import {ArtifactId, ExpeditionId, StateDataId, BrowserSessionStateId} from "../../types/ids";
import {BrowserSessionService} from "../../services/browsersession.service";
import {DateTime} from "../../types/base-types";
import moment from 'moment';
import {StatedataViewerComponent, StatedataViewerToolConfig} from "../statedataviewer/statedataviewer.component";
import {isDefined} from "../../utils/utils";
import {FeatureService} from "../../services/feature.service";
import {Artifact} from "../../types/artifact";
import {ModalToolContainerService} from '../modaltoolcontainer/modaltoolcontainer.service';

@Component({
    selector: 'wm-artifact',
    templateUrl: './artifact.component.html',
    styleUrls: ['./artifact.component.less']
})
export class ArtifactComponent implements OnChanges {

    @Input()
    artifactId: ArtifactId;

    @Input()
    browserSessionId: ExpeditionId;

    @Input()
    associatedState?: BrowserSessionStateId;

    @Input()
    referenceTime?: DateTime;// = "1970-01-01T00:00:00Z";

    @Input()
    summary?: boolean = false;

    artifact: Artifact;

    timeDiff = "";

    constructor(private browserSessionService: BrowserSessionService, private toolService: ModalToolContainerService, private featureService: FeatureService) {}

    diffDates(): void {
        let dateDiff = moment.duration(moment(this.artifact.creationTime).diff(moment(this.referenceTime)));
        let hours = dateDiff.hours();
        let minutes = dateDiff.minutes();
        let seconds = dateDiff.seconds();

        this.timeDiff = (hours ? hours + 'h' : '') + (minutes ? minutes + 'm' : '') + seconds + "s";
    }

    ngOnChanges() {
        this.browserSessionService.getBrowserSessionArtifact$(this.browserSessionId, this.artifactId).subscribe(artifact => {
            this.artifact = artifact;
            this.diffDates();
        });
    }

    openStatedataViewer(stateDataId: StateDataId, stateId: BrowserSessionStateId) {
        this.toolService.openTool(StatedataViewerComponent, new StatedataViewerToolConfig(stateDataId, stateId));
    }
}
